module.exports = __webpack_public_path__ + "img/logo.38e2f54a.png";